<template>
  <div>
    <el-button v-if="isLoginFail" @click="goIAMLogin">重新登录</el-button>
    <div v-else>IAM登录中，请稍后...</div>
  </div>
</template>
<script>
import { goIAMLogin } from "@/utils/iam.js"
import store from '@/store'
import WatermarkUtil from "@/utils/watermark";

export default {
  name: "iamLogin",
  data() {
    return {
      isLoginFail: false,
      goIAMLogin,
    }
  },
  created() {
    this.init();
  },
  methods: {
    // 解析cas重定向地址参数
    getParams() {
      // 提取 query string 中的 code
      const location = window.location

      const codeMatch = location.hash.match(/[?&]code=([^&]*)/);
      const code = codeMatch ? decodeURIComponent(codeMatch[1].replace(/\+/g, ' ')) : null;
      
      // 提取 hash fragment 中的 query 参数
      // const hashQueryMatch = location.hash.match(/[?&]query=([^&]*)/);
      // const query = hashQueryMatch ? decodeURIComponent(hashQueryMatch[1].replace(/\+/g, ' ')) : null;
      return { code }
    },
    init() {
      const { code } = this.getParams()
      if (!code) {
        goIAMLogin()
      } else {
        this.getInfoToken(code);
      }
    },
    getInfoToken(code) {
      this.$httpAuth
        .post("/v1/backendOperatorRpc/iamLogin", {
          code,
        })
        .then(res => {
          const { token, profile, roles } = res?.data ?? {}
          setTimeout(() => {
            store.commit('SET_TOKEN', token)
            store.commit('SET_USER', profile)
            store.commit('SET_ROLES', roles)
            store.commit("SET_ROUTERS", []);

            WatermarkUtil.initWatermark();
            this.$router.push({
              path: '/',
            })
          }, 1000)
        }).catch(e=> { this.isLoginFail = true })
    },
  }
}
</script>